// extracted by mini-css-extract-plugin
export default {"LabelWithIcon":"PositionCard_LabelWithIcon__wrxEY","limited":"PositionCard_limited__oomOU","dropdown-icon":"PositionCard_dropdown-icon__7cv8O"};